{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "title": "Counters",
  "type": "object",
  "additionalProperties": false,
  "required": [
    "items"
  ],
  "properties": {
    "backgroundMediaId": {
      "title": "Background image",
      "type": [
        "string",
        "null"
      ],
      "pattern": "^[0-9a-fA-F-]{36}$",
      "x-ui": "media"
    },
    "items": {
      "title": "Counters",
      "type": "array",
      "maxItems": 4,
      "x-ui": "list",
      "x-itemTitle": "label",
      "items": {
        "type": "object",
        "additionalProperties": false,
        "required": [
          "icon",
          "value",
          "label"
        ],
        "properties": {
          "icon": {
            "title": "Icon",
            "enum": [
              "flaticon-happy",
              "flaticon-automobile-with-wrench",
              "flaticon-mark",
              "flaticon-first-prize-trophy"
            ],
            "x-ui": "select"
          },
          "value": {
            "title": "Value",
            "type": "integer",
            "minimum": 0,
            "maximum": 1000000
          },
          "suffix": {
            "title": "Suffix",
            "type": "string",
            "maxLength": 5
          },
          "label": {
            "title": "Label",
            "type": "string",
            "maxLength": 80
          }
        }
      }
    }
  }
}
